module.exports = __webpack_public_path__ + "static/media/dump-truck.d78649e7.svg";